import script from "./uploadImage.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadImage.vue?vue&type=script&setup=true&lang=js"

import "./uploadImage.vue?vue&type=style&index=0&id=caa78ee2&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caa78ee2"]])

export default __exports__